import axios from 'axios';
import {baseUrl} from "./env_base"
// process.env.NODE_ENV环境
// 获得相应环境下的地址
axios.defaults.headers.common['resform'] = "jy"
axios.defaults.headers.common['Content-Type'] = "application/json"
let baseURLObj = baseUrl[process.env.NODE_ENV] //获得当前环境下的页面根路径
const getUrl = (url) => {
    let baseUrl = ""
    if(url){
        url.match(/\/news/) && (baseUrl = baseURLObj["news"]);
        url.match(/\/content/) && (baseUrl = baseURLObj["content"]);
    }
    url = baseUrl + url
    return url
}
export const get = (url,params)=>{
    params = params || {};
    url = getUrl(url);
    return new Promise((resolve,reject)=>{
        // axiso 自带 get 和 post 方法
        axios.get(url,{
            params,
        }).then(res=>{
            if(res.status===200){
                resolve(res.data);
            }else{
                reject(res)
                alert(res.data.msg)
            }
        }).catch(error=>{
            reject(error)
            alert('网络异常');
        })
    })
}

export const post = (url,params)=>{
    params = params || {};
    url = getUrl(url);
    return new Promise((resolve,reject)=>{
        axios.post(url,params).then(res=>{
            if(res.status===200){
                resolve(res.data);
            }else{
                reject(res)
                alert(res.data.msg);
            }
        }).catch(error=>{
            reject(error)
            alert('网络异常');
        })
    })
}